var map = {
	"./back_items-sprite-2x.png": "da6c",
	"./carpets-sprite-2x.png": "eb13",
	"./chairs-sprite-2x.png": "f6b9",
	"./deco-sprite-2x.png": "1a47",
	"./lamps-sprite-2x.png": "e066",
	"./wall_items-sprite-2x.png": "6627"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "835f";